module.exports = __webpack_public_path__ + "static/MessageBirdAPIKey-d4be4e8e1d60ee6105ead24baf092476.png";